var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
import { isNil } from '../../core/utils';
export function getDerivedErrorConfig(globalErrorConfig, customErrorConfig) {
    var _a = globalErrorConfig || {}, globalShowError = _a.showError, _b = _a.errorRules, globalErrorRules = _b === void 0 ? [] : _b, _c = _a.shouldShowError, globalShouldShowError = _c === void 0 ? true : _c, _d = _a.ignoredErrorCodes, globalIgnoredErrorCodes = _d === void 0 ? [] : _d;
    var _e = customErrorConfig || {}, customShowError = _e.showError, _f = _e.errorRules, customErrorRules = _f === void 0 ? [] : _f, customShouldShowError = _e.shouldShowError, _g = _e.ignoredErrorCodes, customIgnoredErrorCodes = _g === void 0 ? [] : _g;
    var showError = customShowError || globalShowError;
    var errorRules = __spreadArray(__spreadArray([], __read(customErrorRules)), __read(globalErrorRules));
    var ignoredErrorCodes = __spreadArray(__spreadArray([], __read(globalIgnoredErrorCodes)), __read(customIgnoredErrorCodes));
    var shouldShowError = customShouldShowError;
    if (isNil(customShouldShowError)) {
        shouldShowError = globalShouldShowError;
    }
    return {
        showError: showError,
        errorRules: errorRules,
        shouldShowError: shouldShowError,
        ignoredErrorCodes: ignoredErrorCodes,
    };
}
//# sourceMappingURL=utils.js.map